export default "__VITE_ASSET__BVmTwpw5__"